import api from "helpers/api";
import apiLogin from "helpers/apiLogin";


export const login = async (data) => {
    try {
        const response = await api.post("/facility/user_login", {
            userId: data.id,
            password: data.password,
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const logout = async (data) => {
    try {
        const response = await api.post("/facility/user_logout", {
            userId: data.id,
            parkingId: data.parkingId
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const onRefreshToken = async (refreshToken) => {
    try {
        const response = await api.post("/facility/refresh_token", {
            refreshToken: refreshToken,
        });
        return response;
    } catch (error) {
        throw error;
    }
}


export const changePassword = async (data) => {
    try {
        const response = await api.post("/facility/changePassword", {
            userId: data.id,
            newPassword: data.password,
        });
        return response;
    } catch (error) {
        console.error("Change password error:", error.response?.data || error.message);
        return null;
    }
}

export const getServerTime = async (data) => {
    try {
        const response = await api.post("/facility/get_servertime", data?.dateTime ? {
            dateTime: data?.dateTime
        } : {});
        return response;
    } catch (error) {
        throw error;
    }
}

export const loginAttendance = async (data) => {
    try {
        const response = await api.post("/facility/login_attendance", {
            parkingId: data.parkingId,
            userId: data.userId,
            attendanceNote: data.attendanceNote
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const logoutAttendance = async (data) => {
    try {
        const response = await api.post("/facility/logout_attendance", {
            parkingId: data.parkingId,
            userId: data.userId,
            leaveWorkNote: data.leaveWorkNote
        });
        return response;
    } catch (error) {
        throw error;
    }
}

